var map = {
	"./icons/caret/down.svg": "./src/assets/icons/caret/down.svg",
	"./icons/caret/left.svg": "./src/assets/icons/caret/left.svg",
	"./icons/caret/right.svg": "./src/assets/icons/caret/right.svg",
	"./icons/caret/up.svg": "./src/assets/icons/caret/up.svg",
	"./icons/check/rounded.svg": "./src/assets/icons/check/rounded.svg",
	"./icons/chevron/down.svg": "./src/assets/icons/chevron/down.svg",
	"./icons/chevron/left.svg": "./src/assets/icons/chevron/left.svg",
	"./icons/chevron/right.svg": "./src/assets/icons/chevron/right.svg",
	"./icons/chevron/up.svg": "./src/assets/icons/chevron/up.svg",
	"./icons/clipboard.svg": "./src/assets/icons/clipboard.svg",
	"./icons/close.svg": "./src/assets/icons/close.svg",
	"./icons/copy.svg": "./src/assets/icons/copy.svg",
	"./icons/refresh.svg": "./src/assets/icons/refresh.svg",
	"./icons/save.svg": "./src/assets/icons/save.svg",
	"./icons/timer.svg": "./src/assets/icons/timer.svg",
	"./icons/user.svg": "./src/assets/icons/user.svg",
	"./img/avatar.svg": "./src/assets/img/avatar.svg",
	"./img/close-blue.svg": "./src/assets/img/close-blue.svg",
	"./img/close.svg": "./src/assets/img/close.svg",
	"./img/confused-person.svg": "./src/assets/img/confused-person.svg",
	"./img/envelope.svg": "./src/assets/img/envelope.svg",
	"./img/facebook-inverse.svg": "./src/assets/img/facebook-inverse.svg",
	"./img/facebook.svg": "./src/assets/img/facebook.svg",
	"./img/hamburger.svg": "./src/assets/img/hamburger.svg",
	"./img/instagram-inverse.svg": "./src/assets/img/instagram-inverse.svg",
	"./img/instagram.svg": "./src/assets/img/instagram.svg",
	"./img/link.svg": "./src/assets/img/link.svg",
	"./img/linkedin-inverse.svg": "./src/assets/img/linkedin-inverse.svg",
	"./img/linkedin.svg": "./src/assets/img/linkedin.svg",
	"./img/logo.svg": "./src/assets/img/logo.svg",
	"./img/plus-box.svg": "./src/assets/img/plus-box.svg",
	"./img/quote.svg": "./src/assets/img/quote.svg",
	"./img/save.svg": "./src/assets/img/save.svg",
	"./img/search.svg": "./src/assets/img/search.svg",
	"./img/twitter-inverse.svg": "./src/assets/img/twitter-inverse.svg",
	"./img/twitter.svg": "./src/assets/img/twitter.svg",
	"./url/a-on-black.svg": "./src/assets/url/a-on-black.svg",
	"./url/a-on-white.svg": "./src/assets/url/a-on-white.svg",
	"./url/clipboard.svg": "./src/assets/url/clipboard.svg",
	"./url/events.svg": "./src/assets/url/events.svg",
	"./url/newsletter.svg": "./src/assets/url/newsletter.svg",
	"./url/tag.svg": "./src/assets/url/tag.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets recursive ^\\.\\/.*\\.svg$";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = ./src/assets recursive ^\.\/.*\.svg$
// module chunks = 1